export default {
  data: () => {
    return {
      isAddMessageEnabled: false,
      editorOptionForMessage: {
        placeholder: "Enter custom message text",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      }
    };
  },

  watch: {
    isAddMessageEnabled(val) {
      this.$set(this.question, "isAddMessageEnabled", val);
    }
  },

  mounted() {
    this.isAddMessageEnabled = this.question.isAddMessageEnabled;
  },

  methods: {
    toggleMessageTextInput(clearText = false) {
      this.isAddMessageEnabled = !this.isAddMessageEnabled;

      if (clearText === true) {
        this.question.messageBody = "";
      }
    }
  }
};
